import React, { useEffect, useState } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Toolbar, CircularProgress } from "@material-ui/core";
import backArrow from "../../../assets/images/backArrow.png";
import editIcon from "../../../assets/images/editIcon.png";
import schoolLogo from "../../../assets/images/default_school.png";
import MaterialTable from "material-table";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Link, useParams } from "react-router-dom";
import { map, size } from "lodash";
import PropTypes from "prop-types";
import Popover from "@material-ui/core/Popover";
import userService from "../../../services/user.service";
import { getFromLocalStorage } from "../../../utils/webStorage";
import CountDetails from "../Popups/CountDetails";

const SportsDetails = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const schoolId = getFromLocalStorage("schoolId");
  const [countPopup, setCountPopup] = useState(false);
  const [data, setData] = useState([]);
  const { sportsId } = useParams();
  const [heading, setHeading] = useState("");
  const [loading, setLoading] = useState(false);

  const [sportData, setSportData] = useState({});

  const closeDialog = () => {
    setCountPopup(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  useEffect(() => {
    setLoading(true);
    userService
      .getSportById(sportsId, schoolId)
      .then((res) => {
        const data = res.data.data;
        setSportData(data);
        setLoading(false);
      })
      .catch((err) => {});
  }, []);

  const setCountInformation = (heading, countData) => {
    setHeading(heading);
    setData(countData);
    setCountPopup(true);
  };

  return (
    <div>
      <div className={loading ? "gray-out" : ""}>
        <SchoolAdminDashboard />
        <div className="content-layout p-0">
          <Toolbar className="tb-p">
            <div className="mng-add-header stickyy mg-bottom-0">
              <div>
                <p>
                  <Link to="/sports">
                    <span className="fs-22 black semi-bold header-nm">
                      Sports
                    </span>
                  </Link>
                  <img className="mb-1" src={backArrow} alt=" " />
                  <span className="fs-22 black  semi-bold header-nm">
                    {sportData.sportName}
                  </span>
                </p>
              </div>
              <div>
                <Link to={`/editsports/${sportsId}`}>
                  <img src={editIcon} className="cp icon-hover" alt=" " />
                </Link>
              </div>
            </div>
          </Toolbar>
          <div>
            <div className="mng-add-header mg-bottom-0 mg-top-0 header-height border-temdtls">
              <div>
                <div className="dflex align-items-center ml-1">
                  <img
                    className="details-profile img-fluid mg-right-10"
                    src={
                      sportData.uploadedLogo
                        ? sportData.uploadedLogo.filePath
                        : schoolLogo
                    }
                    alt="PIC"
                  />
                  <div>
                    <label className="fs-30 bold athlete-nm mg-bottom-0">
                      {sportData.sportName}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="row">
                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                ></Popover>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 col-md-12  w-100 plr pt-1">
                <div>
                  <div className="col-12 col-lg-12 col-md-10  w-100 plr pt-1 mt-3  team-details fs-18 pd-10">
                    <div className="clear10 col-md-12"></div>
                    <div className="row p-1">
                      <div className="col-12 col-lg-4 col-md-4 fmlabel">
                        <label>Date Joined</label>
                      </div>
                      <div className="col-12 col-lg-8 col-md-8">
                        <p>{sportData.createdOn}</p>
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-12 col-lg-4 col-md-4 fmlabel">
                        <label>Sports</label>
                      </div>
                      <div className="col-12 col-lg-8 col-md-8">
                        <p>{sportData?.sportName}</p>
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-12 col-lg-4 col-md-4 fmlabel">
                        <label>Team Admin</label>
                      </div>
                      <div className="col-12 col-lg-8 col-md-8 d-flex-align-cent">
                        <p className="width-10">
                          {sportData.teamAdminCount
                            ? sportData.teamAdminCount
                            : "0"}
                        </p>
                        {sportData.teamAdminCount && (
                          <button
                            className="view-details-btn"
                            onClick={() =>
                              setCountInformation(
                                "Team Admin Details",
                                sportData.teamAdminList
                              )
                            }
                          >
                            View Details
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-12 col-lg-4 col-md-4 fmlabel">
                        <label>Coaches</label>
                      </div>
                      <div className="col-12 col-lg-8 col-md-8 d-flex-align-cent">
                        <p className="width-10">
                          {sportData.coachCount ? sportData.coachCount : 0}
                        </p>
                        {sportData?.coachCount && (
                          <button
                            className="view-details-btn"
                            onClick={() =>
                              setCountInformation(
                                "Coach Details",
                                sportData.coacheList
                              )
                            }
                          >
                            View Details
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="row p-1 d-flex-align-cent">
                      <div className="col-12 col-lg-4 col-md-4 fmlabel">
                        <label>Athlete</label>
                      </div>
                      <div className="col-12 col-lg-8 col-md-8 d-flex-align-cent">
                        <p className="width-10">
                          {sportData.athleteCount ? sportData.athleteCount : 0}
                        </p>
                        {sportData.athleteCount && (
                          <button
                            className="view-details-btn"
                            onClick={() =>
                              setCountInformation(
                                "Athlete Details",
                                sportData.athleteList
                              )
                            }
                          >
                            View Details
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clear20"></div>
            </div>
          </div>
        </div>
      </div>

      <CountDetails
        heading={heading}
        open={countPopup}
        closeSampleCsvDialog={closeDialog}
        data={data}
      />
      {loading && (
        <CircularProgress className="circle-mark" color="secondary" />
      )}
    </div>
  );
};

export default SportsDetails;
